import axios from 'axios';
import { useEffect, useState } from 'react';
import QUARTER from '../../partials/quarters/quarter';

const YEAR_QUARTERSLISTING = ({yearId, refreshVersion, refreshGoals}) => {

	// console.log('year quarters listing')
	// console.log('yearId')
	// console.log(yearId)

	const [quartersData, setQuartersData] = useState(null)

	//Is there a Current Year active?
	async function currentYearQuarters(yearId) {
		// console.log(yearId)
		try {
			const {data} = await axios.post(
				`${process.env.REACT_APP_WEB_URL}api/quarters/get-current-active-year-quarters`,
				{year_id: yearId},
				{withCredentials:true}
			)
			// console.log('quarters')
			// console.log(data)

			if(data) {
				setQuartersData(data) // Store the quarters data in state
				return true
			}
			setQuartersData(null)
			return false
		}catch(error){
			setQuartersData(null)
			return false
		}
	}

	useEffect(()=>{
		if(yearId) {
			currentYearQuarters(yearId)
		}
	}, [yearId, refreshVersion])

	// console.log(quarterToRender)

	return (
		<>
			{
				quartersData && quartersData.length > 0 ? 
					quartersData.map((quarter, index) => (
						<QUARTER key={quarter._id} quarter={quarter} yearId={yearId} refreshVersion={refreshVersion} refreshGoals={refreshGoals} />
					)) 
				: 
					<h5>No Quarters Found.</h5> 
			}
		</>
	);
};

export default YEAR_QUARTERSLISTING
